<template>
  <div class="main">
    <div
      style="
        display: flex;
        align-items: end;
        gap: 12px;
        justify-content: space-between;
        width: 100%;
      "
    >
      <div class="d-flex align-items-center">
        <div class="form-row align-items-center">
          <div class="col-auto">
            <select
              class="form-control"
              v-model="selectedValue"
              placeholder="Select a search parameter"
            >
              <option value="">Select a search parameter</option>
              <option value="firstName">First Name</option>
              <option value="email">Email</option>
            </select>
          </div>
          <div class="col-auto m-0 p-0" v-if="selectedValue === 'firstName'">
            <div class="input-group m-0">
              <input
                type="text"
                class="form-control"
                id="inlineFormInputGroup"
                placeholder="First Name"
                v-model="firstName"
              />
            </div>
          </div>
          <div class="col-auto m-0 p-0" v-if="selectedValue === 'email'">
            <div class="input-group m-0">
              <input
                type="text"
                class="form-control"
                id="inlineFormInputGroup"
                placeholder="Email"
                v-model="email"
              />
            </div>
          </div>

          <div class="col-auto">
            <button
              type="submit"
              class="btn btn-primary"
              @click="refresh('filter')"
            >
              Search
            </button>
          </div>

          <div class="col-auto">
            <button class="btn btn-info" @click="refresh('refresh')">
              Refresh
            </button>
          </div>
        </div>
      </div>

      <router-link class="btn btn-info m-0" :to="`/dashboard/create-user`">
        Create Admin
      </router-link>
    </div>

    <div class="spinner-grow" role="status" v-if="loading === true"></div>
    <div class="alert alert-danger" role="alert" v-if="error === true">
      {{ errorMsg }}
    </div>

    <div class="col-12 p-0">
      <div
        class="card-plain"
        style="
          align-items: center;
          justify-content: center;
          display: flex;
          padding: 15px 0;
        "
      >
        <div class="table-full-width table-responsive w-100">
          <table class="table">
            <thead class="thead-dark">
              <tr>
                <th scope="col" class="text-center">S/N</th>
                <th scope="col" class="text-center">First Name</th>
                <th scope="col" class="text-center">Last Name</th>
                <th scope="col" class="text-center">Email</th>
                <th scope="col" class="text-center">Phone Number</th>
                <th scope="col" class="text-center">User Role</th>
                <th scope="col" class="text-center">Disabled</th>
                <th scope="col" class="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(user, index) in users" :key="user._id">
                <th class="text-center">
                  {{ limit * (page - 1) + (index + 1) }}
                </th>
                <td class="text-center">{{ user.firstName }}</td>
                <td class="text-center">{{ user.lastName }}</td>
                <td class="text-center">{{ user.email }}</td>
                <td class="text-center">{{ user.phoneNumber }}</td>
                <td class="text-center">{{ displayRoleOrType(user) }}</td>
                <td class="text-center">{{ user.disabled }}</td>
                <td class="text-center">
                  <!-- <drop-down class="nav-item" title="Options" id="list">
                      <div class="p-2"> -->
                  <router-link :to="`/dashboard/user/${user._id}`">
                    View Details
                  </router-link>
                  <!-- </div>
                    </drop-down> -->
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="pagination" style="justify-content: space-between; width: 100%">
      <div
        class="to-flex"
        style="display: flex; align-items: center; gap: 10px"
      >
        <button
          class="btn"
          :disabled="hasPrevPage === false"
          @click="refresh('previous')"
        >
          Previous
        </button>

        <span>Page {{ currentPage }} of {{ totalPages }}</span>

        <button class="btn" :disabled="!hasNextPage" @click="refresh('next')">
          Next
        </button>
      </div>

      <div class="p-2">
        <div class="btn">Total Records: {{ totalDocs }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "../store/axios";
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      error: false,
      users: [],
      errorMsg: "",
      loading: false,
      moment,
      currentPage: 1,
      page: 1,
      totalDocs: 0,
      limit: 20,
      totalPages: 0,
      hasPrevPage: false,
      hasNextPage: true,
      prevPage: null,
      nextPage: null,
      firstName: "",
      email: "",
      selectedValue: "",
    };
  },
  methods: {
    // viewAdmin(id){
    //   this.$router.push(`/dashboard/user/${id}`);
    // },
    displayRoleOrType(user) {
      return user.userType ? user.userType : user.roleName;
    },
    async refresh(mode) {
      try {
        this.errorMsg = "";
        this.error = false;
        this.loading = true;
        let payload = {
          page: this.page,
          firstName: this.firstName,
          email: this.email,
        };
        switch (mode) {
          case "next":
            payload = { ...payload, page: this.nextPage };
            this.currentPage = this.nextPage;
            break;
          case "previous":
            payload = { ...payload, page: this.prevPage };
            this.currentPage = this.prevPage;
            break;
        }
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/users`,
          payload,
        );
        const {
          docs,
          hasNextPage,
          hasPrevPage,
          totalPages,
          prevPage,
          nextPage,
          totalDocs,
          page,
        } = res.data.users;
        this.users = docs;
        this.hasPrevPage = hasPrevPage;
        this.hasNextPage = hasNextPage;
        this.totalPages = totalPages;
        this.prevPage = prevPage;
        this.nextPage = nextPage;
        this.totalDocs = totalDocs;
        this.page = page;
      } catch (err) {
        console.log(err);
        this.error = true;
        this.errorMsg = "Unable to Fetch Users";
      }
      this.loading = false;
    },
  },
  async mounted() {
    try {
      this.loading = true;
      const res = await axios.post(`${process.env.VUE_APP_API_URL}/users`, {
        page: this.page,
      });
      const {
        docs,
        hasNextPage,
        hasPrevPage,
        totalPages,
        prevPage,
        nextPage,
        totalDocs,
        page,
      } = res.data.users;
      this.users = docs;
      this.hasPrevPage = hasPrevPage;
      this.hasNextPage = hasNextPage;
      this.totalPages = totalPages;
      this.prevPage = prevPage;
      this.nextPage = nextPage;
      this.totalDocs = totalDocs;
      this.page = page;
    } catch (err) {
      console.log(err);
      this.error = true;
      this.errorMsg = "Unable to Fetch Users";
    }
    this.loading = false;
  },
};
</script>
<style scoped>
.transaction {
  font-size: 12px;
}
th {
  font-size: 12px !important;
}
.spinner-grow {
  position: fixed;
}
#list {
  list-style-type: none;
}
tbody {
  background: #fff !important;
}
.card-plain .card-body {
  padding: 15px 0px !important;
  display: contents;
  width: 100%;
}
</style>
